import BaseLibraryIconSvg from '../BaseLibraryIconSvg';
import type { IconSvgProps } from '../Icon';

export default function PowerPlant(props: IconSvgProps) {
  return (
    <BaseLibraryIconSvg viewBox='0 0 32 32' {...props}>
      <path
        d='M14.8535 11.2197C15.1536 10.9794 15.5646 10.9322 15.9111 11.0986C16.2577 11.2651 16.4785 11.6155 16.4785 12V14.5459L21.1797 11.2158C21.4847 10.9997 21.8847 10.9719 22.2168 11.1435C22.5488 11.3152 22.7577 11.6574 22.7578 12.0312V14.5537L27.4141 11.1894C27.7184 10.9695 28.1207 10.9385 28.4551 11.1094C28.7895 11.2803 29 11.6244 29 12V28C29 28.5523 28.5523 29 28 29H4C3.44772 29 3 28.5523 3 28V12.2363C3.00007 11.6841 3.44776 11.2363 4 11.2363H10.2607C10.813 11.2363 11.2607 11.6841 11.2607 12.2363V14.0947L14.8535 11.2197ZM5 27H27V13.956L22.3438 17.3213C22.0393 17.5413 21.6372 17.5723 21.3027 17.4013C20.9683 17.2304 20.7578 16.8863 20.7578 16.5107V13.9658L16.0566 17.2969C15.7516 17.513 15.3507 17.5408 15.0186 17.3691C14.6866 17.1973 14.4785 16.8542 14.4785 16.4805V14.081L10.8857 16.958C10.5857 17.1981 10.1746 17.2453 9.82812 17.0791C9.48168 16.9127 9.26089 16.562 9.26074 16.1777V13.2363H5V27Z'
        fill='currentColor'
      />
      <path
        d='M8.33301 3C8.8531 3 9.28689 3.3987 9.33008 3.91699L9.9961 11.917C10.042 12.4674 9.63339 12.9502 9.08301 12.9961C8.53263 13.042 8.04977 12.6334 8.00391 12.083L7.41309 5H6.58692L5.9961 12.083C5.95023 12.6334 5.46737 13.042 4.917 12.9961C4.36662 12.9502 3.95804 12.4674 4.00391 11.917L4.66993 3.91699L4.68262 3.82129C4.76769 3.3504 5.17939 3 5.667 3H8.33301Z'
        fill='currentColor'
      />
      <path
        d='M28 23C28.5523 23 29 23.4477 29 24C29 24.5523 28.5523 25 28 25H16.5C15.9477 25 15.5 24.5523 15.5 24C15.5 23.4477 15.9477 23 16.5 23H28Z'
        fill='currentColor'
      />
      <path
        d='M28 19C28.5523 19 29 19.4477 29 20C29 20.5523 28.5523 21 28 21H20.5C19.9477 21 19.5 20.5523 19.5 20C19.5 19.4477 19.9477 19 20.5 19H28Z'
        fill='currentColor'
      />
    </BaseLibraryIconSvg>
  );
}
